module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "alarm.b8bf4864.png";